import { Card, Progress, Segmented } from "antd";
import { useMemo, useState } from "react";
import { getDateRangeTitles } from "../../helpers/dayjsSetup";

export default function SupplierScoreboard({ data }) {
    const [period, setPeriod] = useState("monthly");
    const dateRangeTitles = getDateRangeTitles();
    const suppliers = useMemo(() => {
        if (!data) return [];
        switch (period) {
            case "monthly":
                return data?.monthly ?? [];
            case "quarterly":
                return data?.quarterly ?? [];
            case "yearly":
                return data?.yearly ?? [];
            default:
                return [];
        }
    }, [data, period]);
    const maxValue = suppliers[0]?.count || 1;
    return (
        <Card className="shadow-sm rounded-xl h-full">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between pb-3">
                <div className="min-w-min">
                    <div className="text-[18px] font-semibold" title="Count of collected containers">
                        Supplier Scoreboard
                    </div>
                    <div className="text-[12px] text-gray-500">
                        Top 5 by container volume
                    </div>
                </div>
                <Segmented
                    options={[
                        { label: "Monthly", value: "monthly", title: dateRangeTitles?.lastMonth },
                        { label: "Quarterly", value: "quarterly", title: dateRangeTitles?.lastQuarter },
                        { label: "Yearly", value: "yearly", title: dateRangeTitles?.last12Months },
                    ]}
                    value={period}
                    onChange={setPeriod}
                    size="middle"
                />
            </div>
            <div className="space-y-2">
                {suppliers?.map((supplier, index) => (
                    <SupplierRow
                        key={supplier?.supplierName}
                        supplier={supplier}
                        maxValue={maxValue}
                        rank={index + 1}
                    />
                ))}
            </div>
        </Card>
    );
}

function SupplierRow({ supplier, maxValue, rank }) {
    const percent = (supplier?.count / maxValue) * 100;
    return (
        <div>
            <div className="flex justify-between items-center text-sm mb-1 gap-3">
                <div className="flex items-center gap-2 min-w-0">
                    <div className="w-6 h-6 flex items-center justify-center text-xs rounded-full bg-cyan-100 text-cyan-700 font-medium">
                        {rank}
                    </div>
                    <span className="truncate">{supplier?.supplierName}</span>
                </div>
                <span className="whitespace-nowrap font-medium">
                    {supplier?.count}
                </span>
            </div>
            <Progress
                percent={percent}
                showInfo={false}
                strokeColor="#03A6A6"
            />
        </div>
    );
}